export default __webpack_public_path__ + "static/media/AdMaterials.b9bfc15e.png";